// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"85da0415","306":"0f3501ee"}[chunkId] + ".chunk.js";
};